import { render, staticRenderFns } from "./UpdatePersonas.vue?vue&type=template&id=283c836f&scoped=true&"
import script from "./UpdatePersonas.vue?vue&type=script&lang=js&"
export * from "./UpdatePersonas.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePersonas.vue?vue&type=style&index=0&id=283c836f&scoped=true&lang=css&"
import style1 from "./UpdatePersonas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c836f",
  null
  
)

export default component.exports